import './App.css';
import RandomColor from './components/RandomColor/RandomColor';

function App() {
  return (
    <div>
      <RandomColor />
    </div>
  );
}

export default App;
